export default {
  create: {
    title: 'Agregar',
    subtitle: 'Sopa de letras',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Juego',
    button: {
      add: 'Nuevo juego',
    },
  },
  list: {
    title: 'Sopa de letras',
    subtitle: 'Lista',
    add: 'Nuevo juego',
  },
  card: {
    title: 'Generador de sopa de letras',
    actions: 'Acciones',
    defaultSettings: 'Configuración predeterminada',
  },
  table: {
    title: 'Juegos activos',
    searchPlaceholder: 'Buscar por algo...',
    groupedTooltip: 'Este grupo contiene varias sopas de letras.',
  },
  form: {
    name: {
      label: 'Nombre:',
      invalid: 'El nombre es obligatorio',
    },
    enableGroupedGeneration: {
      label: 'Generar varios juegos a la vez',
      tooltip: 'Permite crear varios juegos de sopa de letras al mismo tiempo.',
    },
    rows: {
      label: 'Tamaño filas:',
      placeholder: 'Cantidad de filas',
    },
    columns: {
      label: 'Tamaño columnas:',
      placeholder: 'Cantidad de columnas',
    },
    positions: {
      label: 'Posicionamiento de las palabras',
      horizontal: 'Horizontal',
      vertical: 'Vertical',
      diagonal: 'Diagonal',
      inverted: 'Invertida',
      invertedHorizontal: 'Horizontal invertida',
      invertedVertical: 'Vertical invertida',
      invertedDiagonal: 'Diagonal invertida',
    },
    enableSubWord: {
      label: 'Evitar palabra y subpalabra',
    },
    showGrid: {
      label: 'Mostrar cuadrícula',
    },
    showWordPositions: {
      label: 'Resaltar palabras',
    },
    highlightMode: {
      color: 'Color de fondo',
      border: 'Borde suave',
    },
    wordsList: {
      label: 'Lista de palabras (una por línea)',
    },
    totalWords: {
      label: 'Total de palabras:',
    },
    game: 'Juego {n}',
  },
  button: {
    generateAgain: 'Generar de nuevo',
    openAll: 'Abrir todos',
    closeAll: 'Cerrar todos',
  },
  sidebar: {
    exportHint: 'Debe guardar antes de exportar.',
    sendHint: 'Debe guardar antes de enviar.',
    sendToSite: 'Enviar al sitio',
    defaultFileName: 'sopa-de-letras',
  },
  sendModal: {
    description: 'Seleccione los juegos que desea enviar al sitio:',
    selectAll: 'Seleccionar todos',
    noChildren: 'No hay juegos hijos disponibles para enviar.',
  },
  popover: {
    title: 'Palabras posicionadas',
    description: 'fueron utilizadas en la sopa de letras',
  },
  alert: {
    wordsTooBig: {
      intro:
        'Las siguientes palabras son más largas que el espacio disponible en el <strong>juego {gameNumber}</strong>:',
    },
    sendSuccess: 'Enviado con éxito',
    sendError: 'Error al enviar. Inténtelo de nuevo.',
  },
};
